// THẺ "THIẾT LẬP NHANH" của trang kịch bản (16/10/2026) — sửa NGOÀI sơ đồ: từ khoá, kèm ảnh sản phẩm, câu hook, liên kết quảng bá (logic thuần: src/shared/thiet-lap-nhanh.ts).
// Một nút Lưu: gom mọi thay đổi vào MỘT lần lưu sơ đồ (hàng đợi lưu của trang). Trang dựng lại thẻ chỉ khi các giá trị liên quan đổi (chữ đang gõ không mất).
import { busy, clear, h, toast } from "../dom";
import type { SoDo } from "../../../../src/shared/so-do";
import { ANH_CHON_TOI_DA, docAnhChon, ghiAnhChon } from "../../../../src/shared/kho-anh";
import { giaiTapAnh, oAnhChon } from "./chon-anh";
import { taiAnhLenKho } from "./tai-anh-kho";
import { datKemAnh, datTuKhoa, docKemAnh, docLoiVanNhanh, docTuKhoa, ghiLoiVanNhanh, HOOK_TOI_DA, kiemLoiVanNhanh, LIEN_KET_TOI_DA } from "../../../../src/shared/thiet-lap-nhanh";
import type { CheDoKemAnh } from "../../../../src/shared/kem-anh";

export interface NguCanhThietLap {
  luu: (f: (sd: SoDo) => SoDo, ten: string) => Promise<boolean>;
  baoLoi: (m: string | null) => void;
  /** Số ảnh của sản phẩm thư viện đang chọn; null = không biết / không dùng thư viện. */
  soAnhSp: number | null;
  /** Chủ kịch bản — tập ảnh được giải / liệt kê theo kho của chủ này (Super xem kịch bản của Boss). */
  ownerId?: string | null;
  /** Tài khoản đang xem chính là chủ kịch bản → tải ảnh lên Kho ảnh của mình dùng được cho bot của kịch bản này. */
  coTheTaiAnh: boolean;
}

/** Khoá dựng lại thẻ: đổi khi giá trị đang lưu liên quan đổi. */
export const khoaThietLap = (sd: SoDo, soAnhSp: number | null): string =>
  JSON.stringify([sd.giongDieu ?? "", docKemAnh(sd), docTuKhoa(sd), soAnhSp]);

export function theThietLap(sd: SoDo, nc: NguCanhThietLap): HTMLElement {
  const card = h("div", { class: "card kb-thiet-lap", "data-testid": "kb-tl-card" }, h("h3", {}, "Thiết lập nhanh"),
    h("p", { class: "small muted" }, "Chỉnh những thứ hay đổi nhất mà không cần mở từng bước của sơ đồ. Bấm “Lưu thiết lập” để áp cho mọi bước liên quan."));

  // ---- Từ khoá ----
  const tk = docTuKhoa(sd);
  const oTk = tk.map((o) => {
    const inp = h("input", { value: o.giaTri, maxlength: 500, "data-testid": "kb-tl-tu-khoa", title: `Đổi ở ${o.soBuoc} bước đang dùng từ khoá này` });
    return { o, inp, dong: h("label", { class: "f" }, h("span", {}, `${o.nhan}${o.soBuoc > 1 ? ` (${o.soBuoc} bước)` : ""}`), inp) };
  });
  if (oTk.length) card.append(...oTk.map((x) => x.dong));

  // ---- Kèm ảnh ----
  const ka = docKemAnh(sd);
  const chonAnh = h("select", { "data-testid": "kb-tl-kem-anh", disabled: ka.soBuoc === 0, title: "Gửi kèm ảnh sản phẩm (kho ảnh của sản phẩm trong thư viện) ở mọi bước bình luận / trả lời / đăng bài" },
    h("option", { value: "khong", selected: ka.cheDo === "khong" }, "Không kèm ảnh (chỉ chữ)"),
    h("option", { value: "luon", selected: ka.cheDo === "luon" }, "Mọi bình luận / bài đăng kèm một ảnh"),
    h("option", { value: "ti_le", selected: ka.cheDo === "ti_le" }, "Một phần bình luận / bài đăng kèm ảnh"));
  const tiLe = h("input", { type: "number", min: 1, max: 100, value: String(ka.tiLe), "data-testid": "kb-tl-ti-le-anh", title: "Phần trăm câu được kèm ảnh" });
  const tiLeBox = h("label", { class: "f", hidden: ka.cheDo !== "ti_le" }, h("span", {}, "% câu kèm ảnh"), tiLe);
  const canhBaoAnh = h("p", { class: "small warn", "data-testid": "kb-tl-canh-bao-anh", hidden: true });
  // ---- Tập ảnh chọn ngay ở thẻ (17/10/2026): nhiều ảnh trong Kho ảnh / ảnh sản phẩm / album, hoặc tải ảnh mới lên; bot bốc NGẪU NHIÊN một ảnh trong tập (tham số anh_chon của mọi bước hỗ trợ) ----
  let tap = ka.anhChon;      // tập đang soạn trong thẻ
  let daDoiAnh = false;      // chỉ khi người dùng đụng tới ô ảnh mới ghi anh_chon (không ghi đè tập riêng từng bước đặt trong sơ đồ)
  const hopAnh = h("div", { class: "kb-tl-anh", "data-testid": "kb-tl-anh-hop" });
  const canhBaoTap = h("p", { class: "small warn", "data-testid": "kb-tl-canh-bao-tap-anh", role: "status", hidden: true });
  const ghiChuTap = h("p", { class: "small muted", "data-testid": "kb-tl-anh-ghi-chu", hidden: true });
  const ketQuaTai = h("p", { class: "small", "data-testid": "kb-tl-tai-kq", role: "status", hidden: true });
  const tepAnh = h("input", { type: "file", accept: "image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp", multiple: true, class: "sp-an-tep", tabindex: "-1", "aria-hidden": "true", "data-testid": "kb-tl-tai-tep" }) as HTMLInputElement;
  const nutTai = h("button", { type: "button", class: "mini", "data-testid": "kb-tl-tai-anh", disabled: !nc.coTheTaiAnh,
    title: nc.coTheTaiAnh ? "Tải ảnh JPG / PNG / WebP từ máy lên Kho ảnh và thêm ngay vào tập ảnh của kịch bản này (có thể chọn nhiều ảnh một lần)" : "Ảnh tải lên thuộc tài khoản của bạn — kịch bản này của Boss khác nên tải ảnh bằng tài khoản của họ" }, "Tải ảnh lên…");
  nutTai.addEventListener("click", () => tepAnh.click());
  tepAnh.addEventListener("change", () => {
    const fs = [...(tepAnh.files ?? [])]; tepAnh.value = "";
    if (!fs.length) return;
    void busy(nutTai, "Đang tải ảnh…", async () => {
      const kq = await taiAnhLenKho(fs, { conSong: () => card.isConnected });
      const c = docAnhChon(tap);
      const them = kq.ids.filter((id) => !c.anh.includes(id));
      const chua = Math.max(0, ANH_CHON_TOI_DA - (c.anh.length + c.album.length + c.nhan.length + c.sp.length + c.ten.length));
      c.anh.push(...them.slice(0, chua));
      if (them.length) { tap = ghiAnhChon(c); daDoiAnh = true; }
      ketQuaTai.hidden = false;
      const cau = [kq.moi ? `Đã tải lên ${kq.moi} ảnh` : "", kq.trung ? `${kq.trung} ảnh đã có sẵn trong kho (dùng lại, không nhân đôi)` : "", them.length > chua ? `chỉ thêm được ${chua} ảnh vào tập (tối đa ${ANH_CHON_TOI_DA} mục — gom vào album nếu nhiều hơn)` : "", ...kq.loi.map((l) => `“${l.ten}”: ${l.lyDo}`)].filter(Boolean).join(" · ");
      ketQuaTai.className = `small ${kq.loi.length || them.length > chua ? "err" : "ok"}`;
      ketQuaTai.textContent = cau ? `${cau}. ${them.length ? "Bấm “Lưu thiết lập” để áp cho các bước." : ""}`.trim() : "Không có ảnh nào được thêm.";
      veTap(); veAnh();
    });
  });
  const veTap = (): void => {
    clear(hopAnh);
    hopAnh.append(oAnhChon({ nhan: "Ảnh dùng (Kho ảnh)", moTa: "Tập ảnh kèm bình luận / bài đăng" }, tap, {
      testid: "kb-tl-anh", khoa: "tl:anh", ownerId: nc.ownerId ?? null,
      onDoi: (v) => { tap = v; daDoiAnh = true; ketQuaTai.hidden = true; veTap(); veAnh(); },
    }), h("div", { class: "row" }, nutTai, tepAnh));
  };
  let sttTap = 0;
  const veAnh = (): void => {
    tiLeBox.hidden = chonAnh.value !== "ti_le";
    const can = chonAnh.value !== "khong" && ka.soBuoc > 0;
    hopAnh.hidden = !can;
    ghiChuTap.hidden = !(can && !ka.dongNhatAnh && !daDoiAnh);
    ghiChuTap.textContent = "Các bước đang dùng tập ảnh KHÁC NHAU (đặt riêng trong sơ đồ) — giữ nguyên. Chọn / tải ảnh ở đây sẽ áp MỘT tập chung cho mọi bước.";
    const co = tap.trim() !== "";
    // Chưa chọn tập → ảnh sản phẩm trong thư viện như trước; có chọn → kiểm tập thật sự có ảnh trong Kho ảnh (ảnh đã xoá / album trống / nhãn không khớp).
    canhBaoAnh.hidden = !(can && !co && (nc.soAnhSp === null || nc.soAnhSp === 0));
    canhBaoAnh.textContent = nc.soAnhSp === null ? "Chưa chọn ảnh nào và kịch bản chưa chọn sản phẩm trong thư viện — không có ảnh để kèm: chọn / tải ảnh ở ô bên dưới, hoặc chọn sản phẩm ở thẻ bên cạnh." : "Chưa chọn ảnh nào và sản phẩm này chưa có ảnh — chọn / tải ảnh ở ô bên dưới (hoặc thêm ảnh trong Thư viện sản phẩm), nếu không bot chỉ đăng chữ.";
    canhBaoTap.hidden = true;
    if (can && co) {
      const stt = ++sttTap;
      void giaiTapAnh(tap, nc.ownerId ?? null).then((g) => {
        if (stt !== sttTap) return;
        canhBaoTap.hidden = g.anh.length > 0;
        canhBaoTap.textContent = g.anh.length ? "" : `⚠ Tập ảnh đã chọn đang RỖNG${g.thieu.length ? ` (${g.thieu.length} ảnh đã bị xoá khỏi Kho ảnh)` : " (album / nhãn không có ảnh nào)"} — bot sẽ chỉ đăng chữ (hoặc bỏ câu, theo ô “Khi không đính được ảnh”). Chọn hoặc tải ảnh khác.`;
      }).catch(() => { if (stt === sttTap) canhBaoTap.hidden = true; });
    }
  };
  chonAnh.addEventListener("change", veAnh);
  veTap(); veAnh();
  card.append(h("label", { class: "f" }, h("span", {}, "Kèm ảnh"), chonAnh), tiLeBox, canhBaoAnh, ghiChuTap, hopAnh, canhBaoTap, ketQuaTai,
    ka.soBuoc === 0 ? h("p", { class: "small muted" }, "Kịch bản này chưa có bước bình luận / trả lời / đăng bài nào hỗ trợ kèm ảnh.") : h("p", { class: "small muted" }, `Áp cho ${ka.soBuoc} bước. Không chọn ảnh → dùng ảnh sản phẩm của kịch bản; chọn nhiều ảnh → mỗi lần gửi bot lấy NGẪU NHIÊN một ảnh trong tập (tránh lặp cho cùng nick).`));

  // ---- Hook + liên kết ----
  const lv = docLoiVanNhanh(sd.giongDieu);
  const hook = h("input", { type: "checkbox", checked: lv.hook, "data-testid": "kb-tl-hook" });
  const goiYHook = h("input", { value: lv.goiYHook, maxlength: HOOK_TOI_DA, placeholder: "Gợi ý kiểu hook (không bắt buộc), vd: đặt câu hỏi, nêu một con số", "data-testid": "kb-tl-goi-y-hook" });
  const lienKet = h("input", { value: lv.lienKet, maxlength: LIEN_KET_TOI_DA, placeholder: "https://… (link phần mềm cần quảng bá)", "data-testid": "kb-tl-lien-ket", title: "Liên kết được nối vào cuối câu SAU khi AI soạn xong (không qua AI)" });
  card.append(
    h("label", { class: "f" }, h("span", {}, "Câu hook mở đầu"), h("span", { class: "row" }, hook, " Mở đầu mỗi bình luận / bài đăng bằng một câu hook gây chú ý")), goiYHook,
    h("label", { class: "f" }, h("span", {}, "Liên kết quảng bá"), lienKet),
    h("p", { class: "small muted" }, "Liên kết được gắn tự động vào cuối câu bình luận / bài đăng sau khi AI soạn xong (AI không tự viết link, nên trước đây bài đăng ra chỉ có chữ). Cần plugin 0.1.71 trở lên."));

  const luu = h("button", { type: "button", class: "pri", "data-testid": "kb-tl-luu", title: "Lưu từ khoá, kèm ảnh, câu hook và liên kết — áp cho mọi bước liên quan" }, "Lưu thiết lập");
  luu.addEventListener("click", () => void busy(luu, "Đang lưu…", async () => {
    const loi = kiemLoiVanNhanh({ goiYHook: goiYHook.value, lienKet: lienKet.value });
    if (loi) { nc.baoLoi(loi); return; }
    nc.baoLoi(null);
    const ok = await nc.luu((s) => {
      let moi = s;
      for (const x of oTk) { const v = x.inp.value.trim(); if (v && v !== x.o.giaTri) moi = datTuKhoa(moi, x.o.ten, x.o.giaTri, v); }
      moi = datKemAnh(moi, chonAnh.value as CheDoKemAnh, Number(tiLe.value), daDoiAnh ? tap : undefined); // tập ảnh chỉ ghi khi người dùng đụng tới ô ảnh
      const cu = docLoiVanNhanh(moi.giongDieu);
      const giong = ghiLoiVanNhanh({ goc: cu.goc, hook: hook.checked, goiYHook: goiYHook.value, lienKet: lienKet.value });
      return { ...moi, ...(giong ? { giongDieu: giong } : { giongDieu: undefined }) } as SoDo;
    }, "thiết lập nhanh");
    if (ok) toast("Đã lưu thiết lập nhanh", "info");
  }));
  card.append(h("div", { class: "row wrap" }, luu));
  return card;
}
